import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  speakers: [],
  microphones: [],
  defaultSpeaker: '',
  defaultMicrophone: '',
  defaultRingtone: 'ringTone1',
  speakerVolume: 1,
  notificationVolume: 0.4,
};

const audioDevicesSlice = createSlice({
  name: 'audioDevices',
  initialState,
  reducers: {
    setAudioDevices: (state, action) => {
      state.speakers = action.payload.speakers;
      state.microphones = action.payload.microphones;
    },
    setDefaultSpeaker: (state, action) => {
      state.defaultSpeaker = action.payload.speaker;
    },
    setDefaultMicrophone: (state, action) => {
      state.defaultMicrophone = action.payload.microphone;
    },
    setSpeakerVolume: (state, action) => {
      state.speakerVolume = action.payload;
    },
    setNotificationVolume: (state, action) => {
      state.notificationVolume = action.payload;
    },
    setDefaultRingtone: (state, action) => {
      state.defaultRingtone = action.payload;
    },
  }
});

export const { setAudioDevices, setDefaultSpeaker, setDefaultMicrophone, setDefaultRingtone, setSpeakerVolume, setNotificationVolume } = audioDevicesSlice.actions;

//Selectors

export const selectAudioDevices = (state) => state.audioDevices
export const selectSpeakers = (state) => state.audioDevices.speakers
export const selectMicrophones = (state) => state.audioDevices.microphones
export const selectDefaultSpeaker = (state) => state.audioDevices.defaultSpeaker;
export const selectDefaultMicrophone = (state) => state.audioDevices.defaultMicrophone;
export const selectDefaultRingtone = (state) => state.audioDevices.defaultRingtone;
export const selectSpeakerVolume = (state) => state.audioDevices.speakerVolume;
export const selectNotificationVolume = (state) => state.audioDevices.NotificationVolume;

export default audioDevicesSlice.reducer;